export const IN_NETWORK = 'In Network';
export const OUT_NETWORK = 'Out of Network';

export const IN_NETWORK_ABBR = 'IN';
export const OUT_NETWORK_ABBR = 'OON';

export const PDF_MAX_FILE_SIZE = 100 * 1024 * 1024; // 100 MB

export const PVERIFY_ENDPOINTS = [
  {
    "name": "Token",
    "method": "POST",
    "testUrl": "https://api.pverify.com/Test/Token",
    "productionUrl": "https://api.pverify.com/API/Token",
    "testAvailable": true,
    "testResponds": true,
    "testStatusCode": 400,
    "testError": null,
    "verifiedWithProduction": false,
    "productionStatusCode": null,
    "notes": "Test endpoint confirmed available - use this for development!",
    "recommendation": "USE TEST ENVIRONMENT (unlimited calls)"
  },
  {
    "name": "EligibilitySummary",
    "method": "POST",
    "testUrl": "https://api.pverify.com/Test/API/EligibilitySummary",
    "productionUrl": "https://api.pverify.com/API/EligibilitySummary",
    "testAvailable": true,
    "testResponds": true,
    "testStatusCode": 401,
    "testError": null,
    "verifiedWithProduction": false,
    "productionStatusCode": null,
    "notes": "Test endpoint confirmed available - use this for development!",
    "recommendation": "USE TEST ENVIRONMENT (unlimited calls)"
  },
  {
    "name": "GetEligibilitySummary",
    "method": "GET",
    "testUrl": "https://api.pverify.com/Test/API/GetEligibilitySummary",
    "productionUrl": "https://api.pverify.com/API/GetEligibilitySummary",
    "testAvailable": false,
    "testResponds": true,
    "testStatusCode": 404,
    "testError": null,
    "verifiedWithProduction": false,
    "productionStatusCode": null,
    "notes": "Test endpoint returned 404 - not available in test environment",
    "recommendation": "Production only (requires 1 of 20 API calls)"
  },
  {
    "name": "EligibilityInquiry",
    "method": "POST",
    "testUrl": "https://api.pverify.com/Test/API/EligibilityInquiry",
    "productionUrl": "https://api.pverify.com/API/EligibilityInquiry",
    "testAvailable": true,
    "testResponds": true,
    "testStatusCode": 401,
    "testError": null,
    "verifiedWithProduction": false,
    "productionStatusCode": null,
    "notes": "Test endpoint confirmed available - use this for development!",
    "recommendation": "USE TEST ENVIRONMENT (unlimited calls)"
  },
  {
    "name": "GetEligibilityResponse/{id}",
    "method": "GET",
    "testUrl": "https://api.pverify.com/Test/API/GetEligibilityResponse/{id}",
    "productionUrl": "https://api.pverify.com/API/GetEligibilityResponse/{id}",
    "testAvailable": true,
    "testResponds": true,
    "testStatusCode": 401,
    "testError": null,
    "verifiedWithProduction": false,
    "productionStatusCode": null,
    "notes": "Test endpoint confirmed available - use this for development!",
    "recommendation": "USE TEST ENVIRONMENT (unlimited calls)"
  },
  {
    "name": "GetEligibility271/{id}",
    "method": "GET",
    "testUrl": "https://api.pverify.com/Test/API/GetEligibility271/{id}",
    "productionUrl": "https://api.pverify.com/API/GetEligibility271/{id}",
    "testAvailable": true,
    "testResponds": true,
    "testStatusCode": 401,
    "testError": null,
    "verifiedWithProduction": false,
    "productionStatusCode": null,
    "notes": "Test endpoint confirmed available - use this for development!",
    "recommendation": "USE TEST ENVIRONMENT (unlimited calls)"
  },
  {
    "name": "EasyEligibility",
    "method": "POST",
    "testUrl": "https://api.pverify.com/Test/API/EasyEligibility",
    "productionUrl": "https://api.pverify.com/API/EasyEligibility",
    "testAvailable": true,
    "testResponds": true,
    "testStatusCode": 400,
    "testError": null,
    "verifiedWithProduction": false,
    "productionStatusCode": null,
    "notes": "Test endpoint confirmed available - use this for development!",
    "recommendation": "USE TEST ENVIRONMENT (unlimited calls)"
  },
  {
    "name": "EasyEligibilitySummary",
    "method": "POST",
    "testUrl": "https://api.pverify.com/Test/API/EasyEligibilitySummary",
    "productionUrl": "https://api.pverify.com/API/EasyEligibilitySummary",
    "testAvailable": true,
    "testResponds": true,
    "testStatusCode": 400,
    "testError": null,
    "verifiedWithProduction": false,
    "productionStatusCode": null,
    "notes": "Test endpoint confirmed available - use this for development!",
    "recommendation": "USE TEST ENVIRONMENT (unlimited calls)"
  },
  {
    "name": "GetPendingInquiries?DOS=01-01-2018",
    "method": "GET",
    "testUrl": "https://api.pverify.com/Test/API/GetPendingInquiries?DOS=01-01-2018",
    "productionUrl": "https://api.pverify.com/API/GetPendingInquiries?DOS=01-01-2018",
    "testAvailable": true,
    "testResponds": true,
    "testStatusCode": 401,
    "testError": null,
    "verifiedWithProduction": false,
    "productionStatusCode": null,
    "notes": "Test endpoint confirmed available - use this for development!",
    "recommendation": "USE TEST ENVIRONMENT (unlimited calls)"
  },
  {
    "name": "CancelTransaction",
    "method": "POST",
    "testUrl": "https://api.pverify.com/Test/API/CancelTransaction",
    "productionUrl": "https://api.pverify.com/API/CancelTransaction",
    "testAvailable": true,
    "testResponds": true,
    "testStatusCode": 401,
    "testError": null,
    "verifiedWithProduction": false,
    "productionStatusCode": null,
    "notes": "Test endpoint confirmed available - use this for development!",
    "recommendation": "USE TEST ENVIRONMENT (unlimited calls)"
  },
  {
    "name": "Report/EligibilityPDFReport/<elgrequestId>",
    "method": "GET",
    "testUrl": "https://api.pverify.com/Test/API/Report/EligibilityPDFReport/<elgrequestId>",
    "productionUrl": "https://api.pverify.com/API/Report/EligibilityPDFReport/<elgrequestId>",
    "testAvailable": true,
    "testResponds": true,
    "testStatusCode": 302,
    "testError": null,
    "verifiedWithProduction": false,
    "productionStatusCode": null,
    "notes": "Test endpoint confirmed available - use this for development!",
    "recommendation": "USE TEST ENVIRONMENT (unlimited calls)"
  },
  {
    "name": "GetEligibilityDetailsURL/{requestID}",
    "method": "GET",
    "testUrl": "https://api.pverify.com/Test/API/GetEligibilityDetailsURL/{requestID}",
    "productionUrl": "https://api.pverify.com/API/GetEligibilityDetailsURL/{requestID}",
    "testAvailable": true,
    "testResponds": true,
    "testStatusCode": 401,
    "testError": null,
    "verifiedWithProduction": false,
    "productionStatusCode": null,
    "notes": "Test endpoint confirmed available - use this for development!",
    "recommendation": "USE TEST ENVIRONMENT (unlimited calls)"
  },
  {
    "name": "DentalEligibilitySummary",
    "method": "POST",
    "testUrl": "https://api.pverify.com/Test/API/DentalEligibilitySummary",
    "productionUrl": "https://api.pverify.com/API/DentalEligibilitySummary",
    "testAvailable": true,
    "testResponds": true,
    "testStatusCode": 401,
    "testError": null,
    "verifiedWithProduction": false,
    "productionStatusCode": null,
    "notes": "Test endpoint confirmed available - use this for development!",
    "recommendation": "USE TEST ENVIRONMENT (unlimited calls)"
  },
  {
    "name": "DentalEligibilityBenefitSummary",
    "method": "POST",
    "testUrl": "https://api.pverify.com/Test/API/DentalEligibilityBenefitSummary",
    "productionUrl": "https://api.pverify.com/API/DentalEligibilityBenefitSummary",
    "testAvailable": true,
    "testResponds": true,
    "testStatusCode": 401,
    "testError": null,
    "verifiedWithProduction": false,
    "productionStatusCode": null,
    "notes": "Test endpoint confirmed available - use this for development!",
    "recommendation": "USE TEST ENVIRONMENT (unlimited calls)"
  },
  {
    "name": "GetEligibilitySummary/9882795",
    "method": "GET",
    "testUrl": "https://api.pverify.com/Test/API/GetEligibilitySummary/9882795",
    "productionUrl": "https://api.pverify.com/API/GetEligibilitySummary/9882795",
    "testAvailable": true,
    "testResponds": true,
    "testStatusCode": 401,
    "testError": null,
    "verifiedWithProduction": false,
    "productionStatusCode": null,
    "notes": "Test endpoint confirmed available - use this for development!",
    "recommendation": "USE TEST ENVIRONMENT (unlimited calls)"
  },
  {
    "name": "v2/DentalEligibilitySummary",
    "method": "POST",
    "testUrl": "https://api.pverify.com/Test/API/v2/DentalEligibilitySummary",
    "productionUrl": "https://api.pverify.com/API/v2/DentalEligibilitySummary",
    "testAvailable": true,
    "testResponds": true,
    "testStatusCode": 401,
    "testError": null,
    "verifiedWithProduction": false,
    "productionStatusCode": null,
    "notes": "Test endpoint confirmed available - use this for development!",
    "recommendation": "USE TEST ENVIRONMENT (unlimited calls)"
  },
  {
    "name": "GetDentalEligibilitySummary/9882795",
    "method": "GET",
    "testUrl": "https://api.pverify.com/Test/API/GetDentalEligibilitySummary/9882795",
    "productionUrl": "https://api.pverify.com/API/GetDentalEligibilitySummary/9882795",
    "testAvailable": true,
    "testResponds": true,
    "testStatusCode": 401,
    "testError": null,
    "verifiedWithProduction": false,
    "productionStatusCode": null,
    "notes": "Test endpoint confirmed available - use this for development!",
    "recommendation": "USE TEST ENVIRONMENT (unlimited calls)"
  },
  {
    "name": "SameOrSimilarInquiry",
    "method": "POST",
    "testUrl": "https://api.pverify.com/Test/API/SameOrSimilarInquiry",
    "productionUrl": "https://api.pverify.com/API/SameOrSimilarInquiry",
    "testAvailable": true,
    "testResponds": true,
    "testStatusCode": 401,
    "testError": null,
    "verifiedWithProduction": false,
    "productionStatusCode": null,
    "notes": "Test endpoint confirmed available - use this for development!",
    "recommendation": "USE TEST ENVIRONMENT (unlimited calls)"
  },
  {
    "name": "GetSameOrSimilarResponse/1033246",
    "method": "GET",
    "testUrl": "https://api.pverify.com/Test/API/GetSameOrSimilarResponse/1033246",
    "productionUrl": "https://api.pverify.com/API/GetSameOrSimilarResponse/1033246",
    "testAvailable": true,
    "testResponds": true,
    "testStatusCode": 401,
    "testError": null,
    "verifiedWithProduction": false,
    "productionStatusCode": null,
    "notes": "Test endpoint confirmed available - use this for development!",
    "recommendation": "USE TEST ENVIRONMENT (unlimited calls)"
  },
  {
    "name": "PDFReport/SameorSimilar/{id}",
    "method": "GET",
    "testUrl": "https://api.pverify.com/Test/API/PDFReport/SameorSimilar/{id}",
    "productionUrl": "https://api.pverify.com/API/PDFReport/SameorSimilar/{id}",
    "testAvailable": false,
    "testResponds": true,
    "testStatusCode": 404,
    "testError": null,
    "verifiedWithProduction": false,
    "productionStatusCode": null,
    "notes": "Test endpoint returned 404 - not available in test environment",
    "recommendation": "Production only (requires 1 of 20 API calls)"
  },
  {
    "name": "GetSameAndSimilarDetailsURL/{requestID}",
    "method": "GET",
    "testUrl": "https://api.pverify.com/Test/API/GetSameAndSimilarDetailsURL/{requestID}",
    "productionUrl": "https://api.pverify.com/API/GetSameAndSimilarDetailsURL/{requestID}",
    "testAvailable": true,
    "testResponds": true,
    "testStatusCode": 401,
    "testError": null,
    "verifiedWithProduction": false,
    "productionStatusCode": null,
    "notes": "Test endpoint confirmed available - use this for development!",
    "recommendation": "USE TEST ENVIRONMENT (unlimited calls)"
  },
  {
    "name": "SNFInquiry",
    "method": "POST",
    "testUrl": "https://api.pverify.com/Test/API/SNFInquiry",
    "productionUrl": "https://api.pverify.com/API/SNFInquiry",
    "testAvailable": true,
    "testResponds": true,
    "testStatusCode": 401,
    "testError": null,
    "verifiedWithProduction": false,
    "productionStatusCode": null,
    "notes": "Test endpoint confirmed available - use this for development!",
    "recommendation": "USE TEST ENVIRONMENT (unlimited calls)"
  },
  {
    "name": "GetSNFResponse/91931",
    "method": "GET",
    "testUrl": "https://api.pverify.com/Test/API/GetSNFResponse/91931",
    "productionUrl": "https://api.pverify.com/API/GetSNFResponse/91931",
    "testAvailable": true,
    "testResponds": true,
    "testStatusCode": 401,
    "testError": null,
    "verifiedWithProduction": false,
    "productionStatusCode": null,
    "notes": "Test endpoint confirmed available - use this for development!",
    "recommendation": "USE TEST ENVIRONMENT (unlimited calls)"
  },
  {
    "name": "ClaimStatusInquiry",
    "method": "POST",
    "testUrl": "https://api.pverify.com/Test/API/ClaimStatusInquiry",
    "productionUrl": "https://api.pverify.com/API/ClaimStatusInquiry",
    "testAvailable": true,
    "testResponds": true,
    "testStatusCode": 401,
    "testError": null,
    "verifiedWithProduction": false,
    "productionStatusCode": null,
    "notes": "Test endpoint confirmed available - use this for development!",
    "recommendation": "USE TEST ENVIRONMENT (unlimited calls)"
  },
  {
    "name": "GetClaimStatusResponse/53",
    "method": "GET",
    "testUrl": "https://api.pverify.com/Test/API/GetClaimStatusResponse/53",
    "productionUrl": "https://api.pverify.com/API/GetClaimStatusResponse/53",
    "testAvailable": true,
    "testResponds": true,
    "testStatusCode": 401,
    "testError": null,
    "verifiedWithProduction": false,
    "productionStatusCode": null,
    "notes": "Test endpoint confirmed available - use this for development!",
    "recommendation": "USE TEST ENVIRONMENT (unlimited calls)"
  },
  {
    "name": "EstimateCalculation",
    "method": "POST",
    "testUrl": "https://api.pverify.com/Test/API/EstimateCalculation",
    "productionUrl": "https://api.pverify.com/API/EstimateCalculation",
    "testAvailable": false,
    "testResponds": true,
    "testStatusCode": 404,
    "testError": null,
    "verifiedWithProduction": false,
    "productionStatusCode": null,
    "notes": "Test endpoint returned 404 - not available in test environment",
    "recommendation": "Production only (requires 1 of 20 API calls)"
  },
  {
    "name": "CMNInquiry",
    "method": "POST",
    "testUrl": "https://api.pverify.com/Test/API/CMNInquiry",
    "productionUrl": "https://api.pverify.com/API/CMNInquiry",
    "testAvailable": true,
    "testResponds": true,
    "testStatusCode": 401,
    "testError": null,
    "verifiedWithProduction": false,
    "productionStatusCode": null,
    "notes": "Test endpoint confirmed available - use this for development!",
    "recommendation": "USE TEST ENVIRONMENT (unlimited calls)"
  },
  {
    "name": "GetCMNResponse/8",
    "method": "GET",
    "testUrl": "https://api.pverify.com/Test/API/GetCMNResponse/8",
    "productionUrl": "https://api.pverify.com/API/GetCMNResponse/8",
    "testAvailable": true,
    "testResponds": true,
    "testStatusCode": 401,
    "testError": null,
    "verifiedWithProduction": false,
    "productionStatusCode": null,
    "notes": "Test endpoint confirmed available - use this for development!",
    "recommendation": "USE TEST ENVIRONMENT (unlimited calls)"
  },
  {
    "name": "PDFReport/CMN/{id}",
    "method": "GET",
    "testUrl": "https://api.pverify.com/Test/API/PDFReport/CMN/{id}",
    "productionUrl": "https://api.pverify.com/API/PDFReport/CMN/{id}",
    "testAvailable": false,
    "testResponds": true,
    "testStatusCode": 404,
    "testError": null,
    "verifiedWithProduction": false,
    "productionStatusCode": null,
    "notes": "Test endpoint returned 404 - not available in test environment",
    "recommendation": "Production only (requires 1 of 20 API calls)"
  },
  {
    "name": "MBIInquiry",
    "method": "POST",
    "testUrl": "https://api.pverify.com/Test/API/MBIInquiry",
    "productionUrl": "https://api.pverify.com/API/MBIInquiry",
    "testAvailable": true,
    "testResponds": true,
    "testStatusCode": 401,
    "testError": null,
    "verifiedWithProduction": false,
    "productionStatusCode": null,
    "notes": "Test endpoint confirmed available - use this for development!",
    "recommendation": "USE TEST ENVIRONMENT (unlimited calls)"
  },
  {
    "name": "GetMBIResponse/{requestId}",
    "method": "GET",
    "testUrl": "https://api.pverify.com/Test/API/GetMBIResponse/{requestId}",
    "productionUrl": "https://api.pverify.com/API/GetMBIResponse/{requestId}",
    "testAvailable": true,
    "testResponds": true,
    "testStatusCode": 401,
    "testError": null,
    "verifiedWithProduction": false,
    "productionStatusCode": null,
    "notes": "Test endpoint confirmed available - use this for development!",
    "recommendation": "USE TEST ENVIRONMENT (unlimited calls)"
  },
  {
    "name": "InsuranceDiscovery",
    "method": "POST",
    "testUrl": "https://api.pverify.com/Test/API/InsuranceDiscovery",
    "productionUrl": "https://api.pverify.com/API/InsuranceDiscovery",
    "testAvailable": true,
    "testResponds": true,
    "testStatusCode": 401,
    "testError": null,
    "verifiedWithProduction": false,
    "productionStatusCode": null,
    "notes": "Test endpoint confirmed available - use this for development!",
    "recommendation": "USE TEST ENVIRONMENT (unlimited calls)"
  },
  {
    "name": "GetInusuranceDiscoverySummaryResponse/467",
    "method": "GET",
    "testUrl": "https://api.pverify.com/Test/API/GetInusuranceDiscoverySummaryResponse/467",
    "productionUrl": "https://api.pverify.com/API/GetInusuranceDiscoverySummaryResponse/467",
    "testAvailable": true,
    "testResponds": true,
    "testStatusCode": 401,
    "testError": null,
    "verifiedWithProduction": false,
    "productionStatusCode": null,
    "notes": "Test endpoint confirmed available - use this for development!",
    "recommendation": "USE TEST ENVIRONMENT (unlimited calls)"
  },
  {
    "name": "GetInsuranceDiscoveryDetailsURL/{requestID}",
    "method": "GET",
    "testUrl": "https://api.pverify.com/Test/API/GetInsuranceDiscoveryDetailsURL/{requestID}",
    "productionUrl": "https://api.pverify.com/API/GetInsuranceDiscoveryDetailsURL/{requestID}",
    "testAvailable": true,
    "testResponds": true,
    "testStatusCode": 401,
    "testError": null,
    "verifiedWithProduction": false,
    "productionStatusCode": null,
    "notes": "Test endpoint confirmed available - use this for development!",
    "recommendation": "USE TEST ENVIRONMENT (unlimited calls)"
  },
  {
    "name": "PDFReport/InsuranceDiscovery/{id}",
    "method": "GET",
    "testUrl": "https://api.pverify.com/Test/API/PDFReport/InsuranceDiscovery/{id}",
    "productionUrl": "https://api.pverify.com/API/PDFReport/InsuranceDiscovery/{id}",
    "testAvailable": false,
    "testResponds": true,
    "testStatusCode": 404,
    "testError": null,
    "verifiedWithProduction": false,
    "productionStatusCode": null,
    "notes": "Test endpoint returned 404 - not available in test environment",
    "recommendation": "Production only (requires 1 of 20 API calls)"
  },
  {
    "name": "PatientFinderInquiry",
    "method": "POST",
    "testUrl": "https://api.pverify.com/Test/API/PatientFinderInquiry",
    "productionUrl": "https://api.pverify.com/API/PatientFinderInquiry",
    "testAvailable": true,
    "testResponds": true,
    "testStatusCode": 401,
    "testError": null,
    "verifiedWithProduction": false,
    "productionStatusCode": null,
    "notes": "Test endpoint confirmed available - use this for development!",
    "recommendation": "USE TEST ENVIRONMENT (unlimited calls)"
  },
  {
    "name": "PatientFinderInquiryResults",
    "method": "POST",
    "testUrl": "https://api.pverify.com/Test/API/PatientFinderInquiryResults",
    "productionUrl": "https://api.pverify.com/API/PatientFinderInquiryResults",
    "testAvailable": false,
    "testResponds": true,
    "testStatusCode": 404,
    "testError": null,
    "verifiedWithProduction": false,
    "productionStatusCode": null,
    "notes": "Test endpoint returned 404 - not available in test environment",
    "recommendation": "Production only (requires 1 of 20 API calls)"
  },
  {
    "name": "GetPatientFinderResponse/0",
    "method": "GET",
    "testUrl": "https://api.pverify.com/Test/API/GetPatientFinderResponse/0",
    "productionUrl": "https://api.pverify.com/API/GetPatientFinderResponse/0",
    "testAvailable": true,
    "testResponds": true,
    "testStatusCode": 401,
    "testError": null,
    "verifiedWithProduction": false,
    "productionStatusCode": null,
    "notes": "Test endpoint confirmed available - use this for development!",
    "recommendation": "USE TEST ENVIRONMENT (unlimited calls)"
  },
  {
    "name": "GetAllPayers",
    "method": "GET",
    "testUrl": "https://api.pverify.com/Test/API/GetAllPayers",
    "productionUrl": "https://api.pverify.com/API/GetAllPayers",
    "testAvailable": true,
    "testResponds": true,
    "testStatusCode": 200,
    "testError": null,
    "verifiedWithProduction": false,
    "productionStatusCode": null,
    "notes": "Test endpoint confirmed available - use this for development!",
    "recommendation": "USE TEST ENVIRONMENT (unlimited calls)"
  },
  {
    "name": "GetPayerStatus",
    "method": "GET",
    "testUrl": "https://api.pverify.com/Test/API/GetPayerStatus",
    "productionUrl": "https://api.pverify.com/API/GetPayerStatus",
    "testAvailable": true,
    "testResponds": true,
    "testStatusCode": 200,
    "testError": null,
    "verifiedWithProduction": false,
    "productionStatusCode": null,
    "notes": "Test endpoint confirmed available - use this for development!",
    "recommendation": "USE TEST ENVIRONMENT (unlimited calls)"
  },
  {
    "name": "GetPayerStatusStatistics?status=Rejected&checkForLastNumberOfHours=1",
    "method": "GET",
    "testUrl": "https://api.pverify.com/Test/API/GetPayerStatusStatistics?status=Rejected&checkForLastNumberOfHours=1",
    "productionUrl": "https://api.pverify.com/API/GetPayerStatusStatistics?status=Rejected&checkForLastNumberOfHours=1",
    "testAvailable": false,
    "testResponds": true,
    "testStatusCode": 404,
    "testError": null,
    "verifiedWithProduction": false,
    "productionStatusCode": null,
    "notes": "Test endpoint returned 404 - not available in test environment",
    "recommendation": "Production only (requires 1 of 20 API calls)"
  }
];

export const ZUUB_ENDPOINTS = [
  {
    "name": "Insurance Verification Synchronous",
    "method": "POST",
    "url": "https://api-production-001.zuub.com/v1/insurance-verifications",
    "notes": "",
    "path": "zuub-sync-verification"
  },
  {
    "name": "Insurance Verification Asynchronous",
    "method": "POST",
    "url": "https://api-production-001.zuub.com/v1/insurance-verification-requests",
    "notes": "",
    "path": "zuub-async-verification"
  },
  {
    "name": "Webhook",
    "method": "WEBHOOK",
    "url": "webhook",
    "notes": ""
  },
];